"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var IOTP =
/*#__PURE__*/
function () {
  function IOTP(value) {
    (0, _classCallCheck2["default"])(this, IOTP);
    this.value = '';

    if (value instanceof IOTP) {
      this.value = value.value;
    } else {
      this.value = String(value).replace(/\s+/g, '').replace(/-+/g, '');
    }

    return this;
  }
  /**
   * @param {number} maxlength
   * @return {boolean}
   */


  (0, _createClass2["default"])(IOTP, [{
    key: "validate",
    value: function validate() {
      var maxlength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
      var reg = new RegExp('^[0-9]{' + maxlength + '}$');
      return reg.test(this.value);
    }
    /**
     * @param {object} options
     * @return {string}
     */

  }, {
    key: "toString",
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var code = this.value || '',
          i,
          len = code.length,
          result = code,
          separator = options.separator || '-',
          separatedPartLength = options.separatedPartLength || 2;

      if (options.isNeedSeparated) {
        for (i = 0; i < len; i = i + separatedPartLength) {
          result += code.substring(i, separatedPartLength) + separator;
        }

        if (len % separatedPartLength !== 0) {
          result += code.substring(len - len % separatedPartLength, len);
        }
      }

      return result;
    }
  }, {
    key: "is",
    value: function is() {
      console.warn('IOTP prototype.is() is deprecated.');
      return false;
    }
    /**
     * @return {string}
     */

  }, {
    key: "toHtml",
    value: function toHtml() {
      console.warn('IOTP prototype.toHtml() is deprecated. Use .toString()');
      return this.toString();
    }
  }]);
  return IOTP;
}();

var _default = IOTP;
exports["default"] = _default;